import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './BookmarksGrid.styled';
import { useToastStore } from '@/store/useToastStore';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { BookmarksEmpty } from '@/components/BookmarksEmpty/BookmarksEmpty';
import { AdCardNew } from '@/components/AdCardNew';
import { Ad } from '@/api/types/common.types';
import { TransitionSourceBlockEnum } from '@/api/types/ads.types';

interface BookmarksGridProps {
  loading: boolean;
  hasBookmarks: boolean;
  bookmarks: Ad[];
  hasBookmarkButton?: boolean;
  transitionSource?: TransitionSourceBlockEnum;
}

export const BookmarksGrid = ({
  loading,
  bookmarks,
  hasBookmarks,
  hasBookmarkButton = true,
  transitionSource,
}: BookmarksGridProps) => {
  const { t } = useTranslation();
  const { isDesktop } = useBreakpoint();
  const { openToast } = useToastStore();

  const handleRemoveBookmark = useCallback((ad: Ad) => {
    openToast({
      image: ad?.photo?.url,
      text: t('bookmark_collections.unbookmarked'),
    });
  }, []);

  if (!loading && !hasBookmarks) {
    return <BookmarksEmpty />;
  }

  const renderLoader = () => {
    const loaderItems = isDesktop ? 8 : 6;

    return Array.from({ length: loaderItems }).map((_, index) => (
      <AdCardNew key={index} />
    ));
  };

  return (
    <S.BookmarksGrid data-testid="bookmarks-grid">
      {loading
        ? renderLoader()
        : bookmarks.map(bookmark => (
            <AdCardNew
              ad={bookmark}
              key={bookmark.id}
              onRemoveBookmark={handleRemoveBookmark}
              hasBookmarkButton={hasBookmarkButton}
              transitionSource={transitionSource}
            />
          ))}
    </S.BookmarksGrid>
  );
};
